<template>
  <div class="frontpage">
    <Header />

   
    <v-container>
      <!-- <v-snackbar
            top
          >
            New Posts
            <template v-slot:action="{ attrs }">
              <v-btn
                color="pink"
                v-bind="attrs"
                @click="setupdatetofalse()"
              >
               <v-icon dark>
                      mdi-close-circle
                    </v-icon>
              </v-btn>
              
            </template>
          </v-snackbar> -->
      <v-row class="my-4">
        <v-col v-if="this.updatedata == true" class="col-8 col-sm-6 col-md-12 col-lg-12 mx-auto">
           <v-alert
              outlined
              color="primary"
              align="center"
              justify="center"
              dense
            >
            <v-row align="center">
                <v-col class="grow white--text">
                  Update Match Ups
                </v-col>
                <v-col class="shrink">
                  
                  <v-btn 
                  class="closeupdate"
                  depressed
                  text
                  small
                  @click="setupdatetofalse()"
                  >
                  <v-icon color="primary">
                      mdi-refresh
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-alert>
        </v-col>
        <v-col class="col-12">
          <!-- {{this.fightsdata}} -->
          <v-tabs
              v-model="tab"
              background-color="primary"
              centered
              dark
              icons-and-text
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              show-arrows
            >
              <v-tabs-slider></v-tabs-slider>
              

              <v-tab href="#tab-1" class="white--text">
                Current fights
                <!-- <v-icon>mdi-heart</v-icon> -->
              </v-tab>

              <v-tab href="#tab-2" class="white--text">
                Upcoming Fights
                <!-- <v-icon>mdi-phone</v-icon> -->
              </v-tab>

              <v-tab href="#tab-3" class="white--text">
                Past Fights
                <!-- <v-icon>mdi-phone</v-icon> -->
              </v-tab>

              <!-- <v-tab href="#tab-3">
                Nearby
                <v-icon>mdi-account-box</v-icon>
              </v-tab> -->
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item
                value="tab-1"
                class="tabbackground"
              >
              <v-col v-if="todayfights == ''" class="col-12">
                <v-alert outlined type="warning" color="primary" class="text-center">
                  No Fights available
                </v-alert>
              </v-col>

              
                <v-card v-for="fight in todayfights.slice(0, 5)" :key="fight.uid" class="my-5 py-5" dark>
                  <v-row>
                    <v-col class="text-center col-12 col-sm-12 col-md-4 sol-lg-4">
                      <v-row>
                        <v-col class="col-12 text-center">
                        <v-avatar size="100">
                            <img :src="fight.Fighter1Image" alt="John" />
                          </v-avatar>
                          <h3>{{ fight.Fighter1Name }} {{ fight.Fighter1SurName }}</h3>
                          <!-- <h4>{{ fight.Fighter1Percentage }}</h4> -->
                        </v-col>
                      </v-row>
                    </v-col>
                  <v-col class="text-center col-12 col-sm-12 col-md-4 sol-lg-4">
                      <!-- Start Date -->
                    <h4>{{ fight.DateStart}}</h4>
                    <h2>VS</h2>
                    Voting Ends
                    <h4>{{ fight.DateEnd}}</h4>
                    <v-btn
                    class="mt-3 primary"
                      elevation="2"
                      @click="viewfighter(fight.Fightuid, fight.FightTitle, fight)"
                    >
                    <!-- <router-link :to="/foo/${fight.Fightuid}" tag="button">foo</router-link> -->
                    Vote Now
                    </v-btn>
                  </v-col>
                    <v-col class="text-center col-12 col-sm-12 col-md-4 sol-lg-4">
                      <v-row>
                        <v-col class="col-12">
                        <v-avatar size="100">
                            <img :src="fight.Fighter2Image" alt="John" />
                          </v-avatar>
                          <h3>{{ fight.Fighter2Name }} {{ fight.Fighter2SurName }}</h3>
                          <!-- <h4>{{ fight.Fighter2Percentage }}</h4> -->
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>

                <v-col v-if="todayfights != ''" class="col-12 text-center">
                <v-btn class="primary" @click="viewcurrentfights()">
                  View All
                </v-btn>
              </v-col>




              </v-tab-item>
              <v-tab-item
                value="tab-2"
                class="tabbackground"
              >
              <v-col v-if="upcomingfights == ''" class="col-12">
                <v-alert outlined type="warning" color="primary" class="text-center">
                  No Fights available
                </v-alert>
              </v-col>
                 <v-card v-for="upcomingfight in upcomingfights.slice(0, 5)" :key="upcomingfight.uid" class="my-5 py-5" dark>
                  <v-row>
                    <v-col class="text-center col-12 col-sm-12 col-md-4 sol-lg-4">
                      <v-row>
                        <v-col class="col-12 text-center">
                        <v-avatar size="100">
                            <img :src="upcomingfight.Fighter1Image" alt="John" />
                          </v-avatar>
                          <h3>{{ upcomingfight.Fighter1Name }} {{ upcomingfight.Fighter1SurName }}</h3>
                          <!-- <h4>{{ fight.Fighter1Percentage }}</h4> -->
                        </v-col>
                      </v-row>
                    </v-col>
                  <v-col class="text-center col-12 col-sm-12 col-md-4 sol-lg-4">
                      <!-- Start Date -->
                    <h4>{{ upcomingfight.DateStart}}</h4>
                    <h2>VS</h2>
                    Voting Ends
                    <h4>{{ upcomingfight.DateEnd}}</h4>
                    <v-btn
                    class="mt-3 primary"
                      elevation="2"
                      @click="viewfighter(upcomingfight.Fightuid, upcomingfight.FightTitle, upcomingfight)"
                    >
                    <!-- <router-link :to="/foo/${fight.Fightuid}" tag="button">foo</router-link> -->
                    
                    View Fight
                    </v-btn>
                  </v-col>
                    <v-col class="text-center col-12 col-sm-12 col-md-4 sol-lg-4">
                      <v-row>
                        <v-col class="col-12">
                        <v-avatar size="100">
                            <img :src="upcomingfight.Fighter2Image" alt="John" />
                          </v-avatar>
                          <h3>{{ upcomingfight.Fighter2Name }} {{ upcomingfight.Fighter2SurName }}</h3>
                          <!-- <h4>{{ fight.Fighter2Percentage }}</h4> -->
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
                <v-col v-if="upcomingfights != ''" class="col-12 text-center">
                <v-btn class="primary" @click="viewupcomingfights()">
                  View All
                </v-btn>
              </v-col>
              </v-tab-item>
              <v-tab-item
                value="tab-3"
                class="tabbackground"
              >
              <v-col v-if="pastfightsfights == ''" class="col-12">
                <v-alert outlined type="warning" color="primary" class="text-center">
                  No Fights available
                </v-alert>
              </v-col>
                <v-card v-for="pastfight in pastfightsfights.slice(0, 5)" :key="pastfight.uid" class="my-5 py-5" dark>
                  <v-row>
                    <v-col class="text-center col-12 col-sm-12 col-md-4 sol-lg-4">
                      <v-row>
                        <v-col class="col-12 text-center">
                        <v-avatar size="100">
                            <img :src="pastfight.Fighter1Image" alt="John" />
                          </v-avatar>
                          <h3>{{ pastfight.Fighter1Name }} {{ pastfight.Fighter1SurName }}</h3>
                          <!-- <h4>{{ fight.Fighter1Percentage }}</h4> -->
                        </v-col>
                      </v-row>
                    </v-col>
                  <v-col class="text-center col-12 col-sm-12 col-md-4 sol-lg-4">
                      <!-- Start Date -->
                    <h4>{{ pastfight.DateStart}}</h4>
                    <h2>VS</h2>
                    Voting Ends
                    <h4>{{ pastfight.DateEnd}}</h4>
                    <v-btn
                    class="mt-3 primary"
                      elevation="2"
                      @click="viewfighter(pastfight.Fightuid, pastfight.FightTitle, pastfight)"
                    >
                    <!-- <router-link :to="/foo/${fight.Fightuid}" tag="button">foo</router-link> -->
                    View Fight
                    </v-btn>
                  </v-col>
                    <v-col class="text-center col-12 col-sm-12 col-md-4 sol-lg-4">
                      <v-row>
                        <v-col class="col-12">
                        <v-avatar size="100">
                            <img :src="pastfight.Fighter2Image" alt="John" />
                          </v-avatar>
                          <h3>{{ pastfight.Fighter2Name }} {{ pastfight.Fighter2SurName }}</h3>
                          <!-- <h4>{{ fight.Fighter2Percentage }}</h4> -->
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
                <v-col v-if="pastfightsfights != ''" class="col-12 text-center">
                <v-btn class="primary" @click="viewpastfights()">
                  View All
                </v-btn>
              </v-col>
              </v-tab-item>
              <!-- <v-tab-item
                value="tab-3"
              >
                <v-card flat>
                  <v-card-text>suck</v-card-text>
                </v-card>
              </v-tab-item> -->
            </v-tabs-items>
        </v-col>
        <v-col class="col-3">
        </v-col>
      </v-row>
    </v-container>
    <Footer/>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Header from "../components/frontend/header.vue";
import Footer from "../components/frontend/footer.vue"

export default {
  data: () => ({
    mysecondfighterdatas: [],
    myfirstfighterdatas: [],
    fightstoday:[],
    fights: [],
    heyyy:false,
    tab: null,
    // show: false
  }),
  components: { Header, Footer },
  computed: {
    ...mapGetters(['fightsdata', 'todayfights', 'upcomingfights', 'pastfightsfights', 'updatedata'])
  },
  created() {
    this.checkforupdate()
  },
  methods: {
    checkforupdate() {
      if(this.updatedata) {
        console.log('updatedata on page', this.updatedata)
      }
    },
    setupdatetofalse(){
      this.$store.dispatch('setdataupdatetofalse')
    },
     viewfighter(uid, FightTitle, fight) {
       let zayzay =  FightTitle.replaceAll(' ', '-').toLowerCase();
      this.$router.push({
          name: 'FightPage',
          params: {
              FightTitle:zayzay,
              uid: uid,
              fight:fight
          }
      })
    },
      viewpastfights(){
        this.$router.replace('/past-fights');
      },
      viewupcomingfights(){
        this.$router.replace('/upcoming-fights');
      },
      viewcurrentfights() {
        this.$router.replace('/current-fights');
      },
  },
};
</script>

<style lang="sass">
.closeupdate
  background-color: transparent !important
</style>